export const UPLOAD_ZIP_REQUEST = "files/uploadZipFile";
export const UPLOAD_FILE_REQUEST = "files/uploadFile";
export const GET_FILE_REQUEST = "share/getShareFile";
export const EMAIL_SIGNUP_REQUEST = "mail/signup";
